import * as React from 'react';
import { useTranslate } from 'sbx-crm-menu-ui';
import { useNavigate } from 'react-router-dom';

type Props = {
    routes: { label: string, route?: string }[]
};
const NavbarBreadcrumbV2 = ({ routes }: Props) => {
    const { t } = useTranslate('routes');

    const navigate = useNavigate()

    return (
        <nav className="text-sm mb-2 text-gray-600">
            <span className="hover:underline hover:cursor-pointer" onClick={() => {
                window.location.href = window.location.origin
            }}>{t('home')}</span> {routes.map((route, index) => {
            return (
                <span key={index}> &gt; <span
                    onClick={() => route?.route ? navigate(route.route) : null}
                    className={`hover:underline hover:cursor-pointer
                     ${index === routes.length - 1 ? 'font-semibold' : ''}`}>{route.label}</span></span>
            );
        })}

        </nav>
    );
};

export default NavbarBreadcrumbV2;